<script>
  import * as api from '@/utils/api'
  export default {
    name: 'BoardDocuments',
    data: () => ({
      // documents: {
      //   2023: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      //   2024: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September']
      // },
      baseFileUrl: 'https://media.eipl.org/documents/board/',
      documents: {},
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      yearSelected: null,
      yearSelectedLoading: true,
      years: []
    }),
    computed: {},
    methods: {
      async onYearSelect(year) {
        //if (!documents[year])
        //set loading (show getting docs message?)
        //await fetch documents
        // set !loading
        console.log(year)
        this.yearSelectedLoading = true
        setTimeout(() => {
          this.yearSelectedLoading = false
        }, 600)
      }
    },
    async created() {
      const docs = await api.get('page/board')
      const docsByYearMonth = {}
      for (let doc of docs) {
        if (doc?.year) {
          const month = doc.month
          const year = doc.year
          if (!docsByYearMonth?.[year]) docsByYearMonth[year] = {}
          if (!docsByYearMonth?.[year]?.[month]) docsByYearMonth[year][month] = []
          docsByYearMonth[year][month].push(doc)
        }
      }

      // console.log(docsByYearMonth)
      //set documents in state, sort items by month, document name
      for (const year in docsByYearMonth) {
        if (!this.documents?.[year]) this.documents[year] = {}
        for (const month in docsByYearMonth[year]) {
          if (!this.documents?.[year]?.[month]) this.documents[year][month] = []
          const sorted = docsByYearMonth[year][month].sort((a, b) => a.title.localeCompare(b.title))
          this.documents = { ...this.documents, [year]: { ...this.documents[year], [month]: [...sorted] } }
        }
      }
      this.years = Object.keys(this.documents).sort((a, b) => +b - +a)
      this.yearSelected = this.years[0]
      this.yearSelectedLoading = false
      // this.yearSelected = this.years.sort((a, b) => b - a)[0]
      // setTimeout(() => {
      //   this.yearSelectedLoading = false
      // }, 1000)
    }
  }
</script>

<template>
  <v-card max-width="700" width="100%">
    <v-toolbar color="primary" dark height="auto" class="align-end pa-4">
      <v-toolbar-title class="text-h5 font-weight-bold">Board Documents</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-select v-model="yearSelected" color="secondary" hide-details :items="years" label="Year" @change="onYearSelect"></v-select>
    </v-toolbar>
    <v-card-text style="height: 50vh; overflow-y: auto">
      <v-list-item v-if="yearSelectedLoading">
        <v-list-item-content>
          <v-list-item-title>Getting {{ yearSelected }} documents...</v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon>
          <v-progress-circular indeterminate color="primary" :vaule="yearSelectedLoading"></v-progress-circular>
        </v-list-item-icon>
      </v-list-item>
      <v-list v-else dense subheader>
        <!-- <v-list subheader>
          <v-subheader>Month</v-subheader> -->
        <template v-for="(docs, month) in documents[yearSelected]">
          <!-- <v-divider :key="`d1-${month}`"></v-divider> -->
          <v-subheader :key="month + 'h'" v-text="months?.[month] || ''" class="text-body-1 primary--text font-weight-bold"></v-subheader>
          <!-- <v-divider :key="`d2-${month}`"></v-divider> -->
          <v-divider :key="`d1-${month}`"></v-divider>
          <template v-for="doc in docs">
            <v-list-item :key="doc.id">
              <v-list-item-content>
                <v-list-item-title>{{ doc.title }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-btn color="primary" :disabled="!doc?.file" :href="doc?.file ? `${baseFileUrl}${doc.file}` : null" icon small target="_blank">
                  <v-icon color="primary"> mdi-file-download-outline </v-icon></v-btn
                >
              </v-list-item-icon>
            </v-list-item>
            <v-divider :key="'d3' + doc.id"></v-divider>
          </template>
          <!-- <v-list-item :key="month + 'a'">
            <v-list-item-content>
              <v-list-item-title>Agenda</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-btn color="primary" icon small> <v-icon color="primary"> mdi-file-download-outline </v-icon></v-btn>
            </v-list-item-icon>
          </v-list-item>
          <v-divider :key="`d2-${month}`"></v-divider>
          <v-list-item :key="month + 'm'">
            <v-list-item-content>
              <v-list-item-title>Minutes</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-btn color="primary" icon small> <v-icon color="primary"> mdi-file-download-outline </v-icon></v-btn>
            </v-list-item-icon>
          </v-list-item>
          <v-divider :key="`d3-${month}`"></v-divider> -->
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>
